import { useEffect } from "react";

const SCRIPT_ID = "ga4-gtag-script";

export function getMeasurementId() {
    return process.env.REACT_APP_GA_MEASUREMENT_ID?.trim() || "";
}

export function loadGoogleAnalytics(measurementId) {
    if (!measurementId || typeof window === "undefined") return false;

    window.dataLayer = window.dataLayer || [];
    window.gtag =
        window.gtag ||
        function gtag() {
            window.dataLayer.push(arguments);
        };

    if (!document.getElementById(SCRIPT_ID)) {
        const script = document.createElement("script");
        script.id = SCRIPT_ID;
        script.async = true;
        script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(
            measurementId
        )}`;
        document.head.appendChild(script);
    }

    if (!window.__ga4Configured) {
        window.gtag("js", new Date());
        window.gtag("config", measurementId, { send_page_view: false });
        window.__ga4Configured = measurementId;
    }

    return true;
}

export function sendPageView(location) {
    const measurementId = getMeasurementId();
    if (!measurementId || typeof window === "undefined" || !window.gtag) return;

    window.gtag("event", "page_view", {
        page_title: document.title,
        page_location: window.location.href,
        page_path: `${location.pathname}${location.search}`,
    });
}

export function trackEvent(name, params = {}) {
    if (typeof window === "undefined" || !window.gtag || !getMeasurementId())
        return;
    window.gtag("event", name, params);
}

export function GoogleAnalytics() {
    useEffect(() => {
        loadGoogleAnalytics(getMeasurementId());
    }, []);

    return null;
}
